import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HotelInfoComponent } from './hotel-info/hotel-info.component';
import { HotelDialogComponent } from './hotel-dialog/hotel-dialog.component';
import { SharedModule } from '@shared/modules/shared.module';

@NgModule({
  declarations: [HotelInfoComponent, HotelDialogComponent],
  imports: [CommonModule, SharedModule],
  exports: [HotelInfoComponent, HotelDialogComponent],
})
export class HotelModule {}
